import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 8.28467V7.53467H13V8.28467"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="square"
        />
        <path
          d="M10.5 7.53467V13.5347"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M9.25 13.5347H11.75"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="square"
        />
        <path
          d="M14.7569 2.80765L15.1002 2.44415L14.7569 2.80765L17.1866 5.10237C17.3866 5.29128 17.5 5.55426 17.5 5.82939V17.5347C17.5 18.087 17.0523 18.5347 16.5 18.5347H5.5C4.94772 18.5347 4.5 18.087 4.5 17.5347V3.53467C4.5 2.98238 4.94772 2.53467 5.5 2.53467H14.0703C14.3256 2.53467 14.5713 2.63234 14.7569 2.80765Z"
          stroke={color}
          stroke-linecap="round"
        />
        <path
          d="M6.99854 18.5953L6.99854 19.5C6.99854 20.3284 7.67011 21 8.49854 21H18.4985C19.327 21 19.9985 20.3284 19.9985 19.5V8"
          stroke={color}
          stroke-linecap="round"
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'payment');
export default IconComponent;
